import { render, staticRenderFns } from "./ContactMainPage.vue?vue&type=template&id=b3bde518&scoped=true"
import script from "./ContactMainPage.vue?vue&type=script&lang=js"
export * from "./ContactMainPage.vue?vue&type=script&lang=js"
import style0 from "./ContactMainPage.vue?vue&type=style&index=0&id=b3bde518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bde518",
  null
  
)

export default component.exports